module.exports = __webpack_public_path__ + "static/media/cellphone_screen-sales.ca13ff80.png";